import React from "react";
import { Card, Icon, message } from "antd";
import { CompanyService } from "../../services";
import moment from "moment";
class CreditAppraisalGstinPull extends React.Component {
    state={
        gstLatestDate: ""
    }
    getGstData = () => {
        CompanyService.getGstData(this.props.gstin).then(res=>{
            const latestDocUrlObj = res.data?.filter(el=>el.doc_url)?.sort((a, b) => new Date(b.create_date) - new Date(a.create_date));
            const latestDocUrl = latestDocUrlObj.length>0 && latestDocUrlObj[0]?.doc_url;
            if(latestDocUrl){
                this.setState({gstLatestDate:latestDocUrlObj[0]?.create_date});
                window.open(latestDocUrl, '_blank');
            }else{
                message.error("GST Data Not Found");
            }
        }).catch(err=>{
            console.log("inside catch", err);
        })
    }

    render() {
        const { gstLatestDate } = this.state;
        const formattedDate = gstLatestDate ? moment(gstLatestDate)?.format("DD-MM-YYYY") : null;
        return (
            <Card className={"small-card-title"} title={"Gst Pull Data"}>
                <div className="d-flex align-items-center">
                    <Icon type="file-pdf" style={{fontSize: "2rem"}} theme="twoTone" onClick={this.getGstData}/>
                    {formattedDate && <span>{formattedDate}</span>}
                </div>
            </Card>
        );
    }
}

export default CreditAppraisalGstinPull;
